import React, { createContext, useContext, useState, FC, useCallback, useEffect } from 'react';
import { useStorageQuota } from './useStorageQuota';

type ContextType = {
  isOpen: boolean;
  close: () => void;
};

const SpaceStorageToastsContext = createContext<ContextType>({
  isOpen: false,
  close: undefined,
});

export const SpaceStorageToastsProvider: FC = ({ children }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { storageQuotaData, isStorageQuotaVisibilityEnabled } = useStorageQuota();

  const status = storageQuotaData?.status;

  const isWarningStatus = status === 'storageQuotaStatusWarning';
  const isFullStatus = status === 'storageQuotaStatusFull';

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  useEffect(() => {
    if (isStorageQuotaVisibilityEnabled && storageQuotaData && (isFullStatus || isWarningStatus)) {
      open();
    } else {
      close();
    }
  }, [isStorageQuotaVisibilityEnabled, storageQuotaData, isFullStatus, isWarningStatus, open, close]);

  return (
    <SpaceStorageToastsContext.Provider
      value={{
        isOpen,
        close,
      }}
    >
      {children}
    </SpaceStorageToastsContext.Provider>
  );
};

export const useSpaceStorageToast = () => useContext(SpaceStorageToastsContext);
